// API calls of the multi-tenant package "ctrlplane" (server: routes/ctrlplane.ts).
import { apiRequest, publicApiBase } from '../api';

export type PortalSettings = {
  portalBaseUrl: string;        // the stored workspace value ('' = not set)
  portalBaseFromEnv: boolean;   // PORTAL_BASE_URL in the server environment overrides it
  portalBaseEffective: string;  // the address in use ('' = nothing resolves)
  portalBaseDefault: boolean;   // the address in use is the product default (public base URL + /portal)
  corsGap: string;              // the portal's origin when neither CORS_ORIGIN nor PORTAL_CORS_ORIGIN lists it ('' = fine)
};

export const ctrlplaneApi = {
  /** No token: the sign-in pages ask this build's own host for the workspace brand. */
  publicBrand: async (): Promise<{ brand: string }> => {
    const res = await fetch(`${publicApiBase()}/public/brand`);
    if (!res.ok) throw new Error(res.statusText || 'Request failed');
    return res.json();
  },
  portalSettings: (): Promise<PortalSettings> => apiRequest('GET', '/ctrlplane/portal'),
  savePortalBaseUrl: (portalBaseUrl: string): Promise<PortalSettings> => apiRequest('PUT', '/ctrlplane/portal', { portalBaseUrl }),
};
